<template>
    <div class="right pt0">
        <div class="chapter-list">
            <div class="chapter-title flexible aItem-center jc-between">
              <span class="font-MT text-333 f-fwb f20">
                Chapter Lists
                <i class="line"></i>
              </span>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>
